// 组件
import importImg from '@/components/importImg.vue'
import alterForm from '@/components/alterForm'
// 接口
import { getRoomPolicyPricesCollections, postRoomPolicyPricesAdd } from '@/services/rooms.js'
// 其他
import loading from '@/utils/loading.json'
import jsonData from './jsonData'
import constant from '@/utils/constant.js'

export default {
  components: {
    importImg,
    alterForm
  },
  data () {
    return {
      modifyData: {},
      collapseLength: [],
      formData: jsonData.formData
    }
  },
  watch: {
  },
  created () {
    this.init()
  },
  mounted () {
  },
  methods: {
    init () {
      this.collapseLength = [...new Array(this.formData.length).keys()]
      this.$store.state.app.loading = this.$loading(loading)
      getRoomPolicyPricesCollections().then(res => {
        if (res.status === 200) {
          // this.formData[0].createDateItem[1].options = res.data.collections.hotel_rooms
        }
      }).finally(() => {
        this.$store.state.app.loading.close()
      })
    },
    formSubmit (data) {
      this.$store.state.app.loading = this.$loading(loading)
      const obj = JSON.parse(JSON.stringify(data))
      const params = {
        room_policy_price: obj
      }
      params.room_policy_price.hotel_room_policy_id = this.$route.params.room_policy_id
      Object.keys(params.room_policy_price).forEach(res => {
        if (typeof params.room_policy_price[res] === 'boolean') {
          if (params.room_policy_price[res] === true) params.room_policy_price[res] = '1'
          if (params.room_policy_price[res] === false) params.room_policy_price[res] = '0'
        }
      })
      postRoomPolicyPricesAdd(params).then(res => {
        if (res.status === 200) {
          this.$message({
            type: 'success',
            message: this.$t('message.operateSuccess')
          })
          setTimeout(() => {
            this.$router.push({
              name: 'roomPolicyPriceList',
              params: {
                room_policy_id: this.$route.params.room_policy_id
              }
            })
          }, constant.ROUTER_CHANGE_INTERVAL)
        }
      }).finally(() => {
        this.$store.state.app.loading.close()
      })
    }
  }
}
